define("settings/components/navigation-header", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--page__sidebarHeader at--onboardingSkippedProfileConnect__laterLogo">
    <LinkToExternal @model={{@slug}} @route="cluster.schedule.calendar" class="img--logo" />
  </section>
  */
  {
    "id": "lQmGr2kK",
    "block": "[[[10,\"section\"],[14,0,\"o--page__sidebarHeader at--onboardingSkippedProfileConnect__laterLogo\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,0,\"img--logo\"]],[[\"@model\",\"@route\"],[[30,1],\"cluster.schedule.calendar\"]],null],[1,\"\\n\"],[13]],[\"@slug\"],false,[\"link-to-external\"]]",
    "moduleName": "settings/components/navigation-header.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});